import {
  useCallback,
  useEffect,
  useRef,
  useState
} from "react";
const composeDragInfo = (initialX, initialY, x, y, persistentX, persistentY) => {
  const iX = initialX + persistentX;
  const iY = initialY + persistentY;
  return {
    initialX: iX,
    initialY: iY,
    offsetX: x - iX,
    offsetY: y - iY
  };
};
function useMouseDrag(persist = false) {
  const [dragging, setDragging] = useState(false);
  const [initialX, setInitialX] = useState(() => 0);
  const [initialY, setInitialY] = useState(() => 0);
  const [offsetX, setX] = useState(0);
  const [offsetY, setY] = useState(0);
  const target = useRef();
  const state = useRef({
    persistentX: 0,
    persistentY: 0,
    deltaX: 0,
    deltaY: 0
  });
  useEffect(() => {
    state.current = {
      ...state.current,
      deltaX: initialX - offsetX,
      deltaY: initialY - offsetY
    };
  }, [initialX, initialY, offsetX, offsetY]);
  const resetOffset = () => {
    setInitialX(offsetX);
    setInitialY(offsetY);
    setX(offsetX);
    setY(offsetY);
  };
  const handleMouseMove = (event) => {
    const { pageX, pageY } = event;
    setDragging(true);
    setX(pageX);
    setY(pageY);
  };
  const handleMouseUp = useCallback(() => {
    target.current = void 0;
    setDragging(false);
    if (persist) {
      state.current.persistentX += state.current.deltaX;
      state.current.persistentY += state.current.deltaY;
    }
    setInitialX(0);
    setInitialY(0);
    setX(0);
    setY(0);
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  }, [persist]);
  const mouseHandler = useCallback(
    (event) => {
      const { pageX, pageY } = event;
      target.current = event.currentTarget;
      setInitialX(pageX);
      setInitialY(pageY);
      setX(pageX);
      setY(pageY);
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    },
    [handleMouseUp]
  );
  return [
    composeDragInfo(initialX, initialY, offsetX, offsetY, state.current.persistentX, state.current.persistentY),
    dragging,
    mouseHandler,
    resetOffset,
    target.current
  ];
}
export {
  useMouseDrag
};
//# sourceMappingURL=useMouseDrag.js.map
